import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useLoader } from "../contexts/LoaderContext"

export const RouteChangeLoader = () => {
  const location = useLocation()
  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    // Show loader immediately when route changes
    showLoader()

    // Hide loader after 500ms (simulate load time or wait for API call)
    const timeout = setTimeout(() => {
      hideLoader()
    }, 500)

    return () => clearTimeout(timeout)
  }, [location.pathname]) // runs whenever path changes

  return null
}
